import { FEATURES } from '/src/features/_global/constants';
import { NOTIFICATIONS_PERMISSIONS } from '../notifications/permissions';

export const OPTIONS_PERMISSIONS = {
  [FEATURES.OPTIONS]: ({ capabilities }) => ({
    navigate: capabilities?.siteSettings.permissions.nav,
  }),
  [FEATURES.SITE_SETTINGS]: ({ capabilities }) => ({
    navigate: capabilities?.siteSettings.permissions.nav,
    edit: capabilities?.siteSettings.permissions.edit,
  }),
  [FEATURES.SITES]: ({ capabilities }) => ({
    create: capabilities?.sites.permissions.create,
    delete: capabilities?.sites.permissions.delete,
  }),
  [FEATURES.TRACKING_OPTIONS]: ({ capabilities }) => ({
    navigate: capabilities?.trackingOptions.permissions.nav,
    edit: capabilities?.trackingOptions.permissions.edit,
  }),
  [FEATURES.API]: ({ capabilities }) => ({
    navigate: capabilities?.api.permissions.nav,
    edit: capabilities?.api.permissions.edit,
  }),
  ...NOTIFICATIONS_PERMISSIONS,
};
